import { Box, Fade } from '@mui/material';
import { useFormContext } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { ControlledAutocompleteDropdownValueLazy } from 'src/shared/components/form/controlledAutocompleteDropdownValueLazy';
import ControlledDatePicker from 'src/shared/components/form/controlledDatePicker';
import ConsoleHelper from 'src/shared/functions/consoleHelper';
import { useIsMounted } from 'src/shared/hooks/useIsMounted';
import { getResCause } from 'src/shared/services/formSettingService';

type MemberFamilyDeleteSecedePickersProps = {
  checked: true;
};

export const MemberFamilyDeleteSecedePickers = (props: MemberFamilyDeleteSecedePickersProps) => {
  const { checked } = props;
  const { t } = useTranslation();
  const isMounted = useIsMounted();
  const { getValues } = useFormContext();
  return (
    <Fade in={checked}>
      <Box mt={1}>
        <Box my={3}>
          <ControlledDatePicker name='resDate' label={t('member:family.resDate')} />
        </Box>
        <Box mt={3} mb={2}>
          <ControlledAutocompleteDropdownValueLazy
            name='resCause'
            componentWidth='100%'
            value={getValues('resCause')}
            callback={(x) => ConsoleHelper.log(x, 'snurre')}
            fetchMethod={async () => {
              try {
                const result = await getResCause();
                if (isMounted()) {
                  const items = result.data.results[0].extraOptions.filter((x) => x.name !== '');
                  return items;
                }
              } catch (e) {
                if (isMounted()) {
                  ConsoleHelper.log(e);
                }
              }

              return [];
            }}
            nameProp='name'
            label='Utträdesorsak'
          />
        </Box>
      </Box>
    </Fade>
  );
};
